import { styled } from '@abyss/web/tools/styled';
import { Accordion } from '@abyss/web/ui/Accordion';

export const FilterAccordionItem = styled(Accordion.Item, {
  '&.abyss-accordion-item': {
    backgroundColor: '$white',
    borderBottom: '1px solid $gray4',
    padding: '$lg',
  },
});

export const FilterAccordionContent = styled(Accordion.Content, {
  '&.abyss-accordion-content-container': {
    backgroundColor: '$white',
    marginTop: '$md',
  },
  '&.abyss-accordion-content-text': {
    padding: '0',
  },
  span: {
    color: '$black',
    fontWeight: '400',
    lineHeight: '20px',
    fontSize: '16px',
  },
});

export const FilterAccordianTrigger = styled(Accordion.Trigger, {
  '&.abyss-accordion-trigger': {
    fontSize: '$md',
    fontWeight: '$medium',
    lineHeight: '20px',
    color: '$gray7',
    height: '20px',
    minHeight: 'unset',
    padding: '0',
    border: '0px !important',
    backgroundColor: '$white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
});
